import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {UserInfoService} from '@core/user-permissions/user-info.service';
import {CampaignType} from '@app/models/campaign-type';
import {CampaignName} from '@app/models/campaign-name';
import {PageErrorService} from '@app/pages/page-error/service/page-error.service';
import {PageErrorType} from '@app/pages/page-error/classes/page-error-type';
import { FciErrorType } from '@core/api/fci-error-type';
import {HelperService} from '@app/services/helper.service';
import {AuthenticationService} from '@app/services/authentication.service';

@Injectable({providedIn: 'root'})
export class MasterGuard implements CanActivate {
	constructor(
		private router: Router,
		private authenticationService: AuthenticationService,
		private userInfoService: UserInfoService,
		private pageErrorService: PageErrorService,
	) {
	}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		const user = this.userInfoService.user;
		const isLosp = route.data['isLosp'];
		const isAncestorLess = route.data['isAncestorLess'];

		if (!user) {
			this.pageErrorService.show({
				pageErrorType: PageErrorType.default,
				fciErrorType: FciErrorType.emptyContent
			})
			return false;
		}

		// Campaign is not valid
		if (user.campaign.id === null) {
			if (user.isLoggedIn) {
				this.router.navigate(['stories/not-found']);
			} else {
				this.authenticationService.redirectToLoginPage();
			}

			return false;
		}

		// Campaign is for Signed-In users only
		if (HelperService.isOnlySignedInCampaign(user.campaign) && user.isLoggedOut && !isLosp && !isAncestorLess) {
			this.authenticationService.redirectToLoginPage();

			return false;
		}

		if (route.data.campaignIsRequired && user.campaign.name === CampaignName.noCampaign) {
			this.router.navigate(['stories/not-found']);

			return false;
		}

		// Redirect to Login Page
		if (route.data['memberPage'] && user.isLoggedOut && user.campaign.type !== CampaignType.holiday) {
			this.authenticationService.redirectToLoginPage();
			return false;
		}

		return true;
	}
}
